import { createResource } from 'react-resource-router';

import urls from 'src/sections/workspace/urls';
import { createHttpRequest } from 'src/utils/http-request';
import { captureExceptionWithTags } from 'src/utils/sentry';

import { OAUTH_CLIENT_EXPIRY } from '../constants';
import { OAuthClientsResponse } from '../types';

export const oauthClientsResource = createResource<OAuthClientsResponse>({
  type: 'oauth-clients',
  getKey: ({ match: { params }, query }) => {
    const { workspaceSlug } = params;
    const { page = '1' } = query;
    return `${workspaceSlug}/oauth/client/${page}`;
  },
  maxAge: OAUTH_CLIENT_EXPIRY,
  getData: async ({ match: { params }, query }) => {
    const { workspaceSlug } = params;
    const { page = '1' } = query;

    if (!workspaceSlug) {
      throw new Error(
        'This resource must be rendered on a valid route with a workspace slug'
      );
    }

    const apiUrl = urls.api.internal.oauthClients(workspaceSlug, page);

    try {
      return await createHttpRequest<OAuthClientsResponse>('GET', {
        throwErrorType: 'errorObject',
      })(apiUrl);
    } catch (error: unknown) {
      if (error instanceof Error) {
        await captureExceptionWithTags(error);
      }
      throw error;
    }
  },
});
